import React, { useCallback, useEffect, useMemo } from 'react'
import SearchIcon from '@8x8/oxygen-icon/novo/SearchIcon'
import CloseIcon from '@8x8/oxygen-icon/novo/CloseCircleIcon'
import { debounce } from 'debounce'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'

import { searchRecords, setSearchTerm } from '~/actions/salesforce'
import { getSearchText } from '~/selectors/salesforce'
import { translate } from '~/core/translate'
import Input from '~/components/common/input'

const DebounceTime = 500

const StyledInput = styled(Input)`
  svg {
    fill: ${({ theme }) => theme.colorIcon};
  }

  input {
    padding: 12px 11px;
  }
`

const MinSearchLength = 2

const Search = ({ className }) => {
  const dispatch = useDispatch()
  const searchText = useSelector(getSearchText)
  const clear = useCallback(() => {
    dispatch(setSearchTerm(''))
  }, [dispatch])

  const ClearButton = useCallback(() => <CloseIcon onClick={clear} />, [clear])

  const search = useMemo(() =>
    debounce(() => {
      dispatch(searchRecords())
    }, DebounceTime)
  , [dispatch])

  const update = useCallback(e => {
    dispatch(setSearchTerm(e.target.value))
  }, [dispatch])

  useEffect(() => {
    if (searchText.length >= MinSearchLength) {
      search()
    }
  }, [search, searchText])

  return (
    <StyledInput
      className={className}
      iconLeft={SearchIcon}
      iconRight={searchText && ClearButton}
      onChange={update}
      placeholder={translate('salesforce_search')}
      value={searchText}
    />
  )
}

export default Search
